import OrdersDataTable from "../../../../components/dataTable/tables/canteen/OrdersDataTable";

function OrdersPageView() {
  return <OrdersDataTable />;
}

export default OrdersPageView;
